import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { sizeOf } from "../../utils/propTypes";
import css from "./Skeleton.module.css";

const Skeleton = React.forwardRef(
  (
    {
      variant = "text",
      size = "md",
      tone = "surface",
      as: Component = "div",
      width,
      height,
      className,
      style,
      ...rest
    },
    ref,
  ) => {
    const classes = clsx(
      css[variant],
      variant === "text" && css[`size-${size}`],
      css[`tone-${tone}`],
      className,
    );
    const mergedStyle = { width, height, ...style };

    return (
      <Component
        ref={ref}
        className={classes}
        style={mergedStyle}
        aria-hidden="true"
        {...rest}
      />
    );
  },
);

Skeleton.displayName = "Skeleton";

Skeleton.propTypes = {
  variant: PropTypes.oneOf(["text", "circle", "rect"]),
  size: sizeOf("md", "lg", "xl"),
  tone: PropTypes.oneOf(["surface", "onDark"]),
  as: PropTypes.elementType,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  style: PropTypes.object,
};

export default Skeleton;
